import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';
import { Link } from 'react-router-dom';

import { Frame } from 'features/Frames/types';
import { FRAMES_PAGE_URL } from 'utils/defaults';
import { truncateText } from 'utils/truncateText';

import useStyles from './FrameDetailsTitle.styles';

const MAX_LENGTH = 70;
type FrameDetailsTitleProps = {
  currentFrame: Frame;
};
const FrameDetailsTitle = ({ currentFrame }: FrameDetailsTitleProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Link to={FRAMES_PAGE_URL} className={classes.link}>
        <Typography variant="h2" className={classes.text}>
          All Frames
        </Typography>
      </Link>
      <Typography variant="h2">/</Typography>
      <Typography variant="h2" fontWeight="bold">
        {truncateText(currentFrame?.name, MAX_LENGTH)}
      </Typography>
    </div>
  );
};

export default FrameDetailsTitle;
